// extracted by mini-css-extract-plugin
module.exports = {"selection":"CheckboxSelection_selection__tvLMQ","checked":"CheckboxSelection_checked__U3y6g","fullWidth":"CheckboxSelection_fullWidth__aaQnm"};